import type { ReactNode } from "react";
import { SmartImage } from "../SmartImage";

export function JoinPageLayout({
  eyebrow,
  title,
  subtitle,
  children,
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <div className="standard-page join-page">
      <section className="join-hero">
        <SmartImage name="team" alt="都蘭小星團隊與旅人" eager />
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h1>
            {title}
            <span>{subtitle}</span>
          </h1>
        </div>
      </section>
      <div className="join-content prose">{children}</div>
    </div>
  );
}
